export const stationPageRoutesPolicy = ["workspace-agency-overview",];
export const dashboardRoutes = ["workspace-dashboard"];
export const authRoutes = ["auth-forgot-password", "auth-validate", "auth-register", "auth-login"];
